import { isNil, omitBy } from 'lodash';
import request from '@/utils/request';
import {
  datasetEndpoint, conditionEndpoint, conditionsEndpoint,
} from '@/constants/urls';
import buildContext from './context';
import { UserDefinedRestrictionTypes } from '../constants';

const conditions = (code = '') => request({
  url: `${conditionEndpoint(code)}`,
  method: 'GET',
});

const datasetConditions = (entity, code) => request({
  url: conditionsEndpoint(entity, code),
  method: 'GET',
});

const buildPayload = (datasetCondition) => omitBy(
  {
    context: buildContext(datasetCondition),
    configuration: datasetCondition.configuration,
  },
  isNil,
);

const headerBuilders = {
  [UserDefinedRestrictionTypes.ATTACHMENT]: { 'Content-Type': 'multipart/form-data' },
};

const buildHeaders = (datasetCondition) => headerBuilders[datasetCondition?.context?.type] || {};

const create = (datasetCode, datasetCondition) => request({
  url: `${datasetEndpoint(datasetCode)}/conditions/${datasetCondition.condition.code}`,
  data: buildPayload(datasetCondition),
  method: 'POST',
  headers: buildHeaders(datasetCondition),
});

const toggleAdvisory = (datasetCode, datasetCondition) => request({
  url: `${datasetEndpoint(datasetCode)}/conditions/${datasetCondition.id}`,
  data: buildPayload(datasetCondition),
  method: 'PATCH',
});

const update = (datasetCode, datasetCondition) => request({
  url: `${datasetEndpoint(datasetCode)}/conditions/${datasetCondition.id}`,
  data: buildPayload(datasetCondition),
  method: 'PATCH',
  headers: buildHeaders(datasetCondition),

});

const destroy = ({ code, id }) => request({
  url: `${datasetEndpoint(code)}/conditions/${id}`,
  method: 'DELETE',
});

const attachment = ({ code, id }) => request({
  url: `${datasetEndpoint(code)}/conditions/${id}/attachment`,
  method: 'GET',
  responseType: 'blob',
});

const ConditionsService = {
  conditions,
  create,
  datasetConditions,
  destroy,
  attachment,
  toggleAdvisory,
  update,
};

export default ConditionsService;
